export const appsApiLimitsAppGroupRateLimitDatatableAppGroupId =
  "/apps/api_limits/app_group_rate_limit_datatable/(/:app_group_id)";
